import store from '@/store'
import {
  verifyOneTimeLoginTokenAndGetSession,
  AuthTokenResponse,
} from '@/sdk/clients/UserClient'

export const SHOW_ADD_BANK_ACCOUNT_OVERLAY_QUERY_PARAM =
  'showAddBankAccountOverlay'

const verifyTokenAndGetSession = async (
  token: string,
): Promise<AuthTokenResponse> => {
  return verifyOneTimeLoginTokenAndGetSession(token)
}

export default async (to, from, next) => {
  const { token } = to.params
  const pageToRedirect = `/zahlungsmethode?${SHOW_ADD_BANK_ACCOUNT_OVERLAY_QUERY_PARAM}`

  if (store.getters['auth/isAuthenticated']()) {
    store.commit('auth/deleteAuth')
  }

  try {
    const tokens = await verifyTokenAndGetSession(token)

    store.commit('auth/setUserToken', tokens)
    await store.dispatch('user/setIsOneTimeLoginSession')

    next(pageToRedirect)
  } catch (error) {
    next('/login')
  }
}
